import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#505050",
      "fill-rule": "evenodd",
      d: "M10.674 2.514a1.876 1.876 0 0 1 2.652 0l8.954 8.955a.75.75 0 0 1-1.06 1.061l-.97-.97v8.315c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875v-8.316l-.97.971a.75.75 0 0 1-1.06-1.06zm1.592 1.06a.377.377 0 0 0-.531 0L5.25 10.06v9.816c0 .207.168.375.375.375H9v-4.125c0-1.036.84-1.875 1.875-1.875h2.25c1.035 0 1.875.84 1.875 1.875v4.125h3.375a.375.375 0 0 0 .375-.375v-9.816zm-1.39 12.176a.375.375 0 0 0-.376.375v4.125h3v-4.125a.375.375 0 0 0-.375-.375z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }